function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isEqual } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from '../../../../../theme/i18n';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { useFocus, useKeyDown } from '../../hooks';
import { MonthSelectionCell } from './MonthSelectionCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var YearSelectionListItem = _ref => {
  var {
    yearItem,
    isOpen,
    activeMonth,
    goToYear,
    onToggleYear,
    scrollToElement,
    focusedYear,
    onFocusYearChange,
    onBlurYear,
    isActiveYear,
    shouldTriggerScrollToElement,
    handleEscape
  } = _ref;
  var {
    size,
    isMobileDatePicker
  } = useCalendarContext();
  var {
    formatDate
  } = useIntl();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  var itemRef = useRef(null);
  var itemTriggerRef = useRef(null);
  var isFocusedYear = useMemo(() => focusedYear === yearItem.year, [focusedYear, yearItem]);
  var [focusedMonth, setFocusedMonth] = useState();
  var onFocusMonthChange = useCallback(date => {
    var targetMonth = date && yearItem.months.find(month => isEqual(month.date, date) && !month.isDisabled);
    setFocusedMonth(targetMonth === null || targetMonth === void 0 ? void 0 : targetMonth.date);
  }, [yearItem]); // scroll to the opened year item when the year selection is opened for the first time.

  useEffect(() => {
    if (shouldTriggerScrollToElement) {
      scrollToElement(itemRef);
    }
  }, [shouldTriggerScrollToElement, scrollToElement]);
  var isActiveMonth = useCallback(index => {
    var _yearItem$months$acti, _yearItem$months$inde;

    return isActiveYear && ((_yearItem$months$acti = yearItem.months[activeMonth.month]) === null || _yearItem$months$acti === void 0 ? void 0 : _yearItem$months$acti.date) === ((_yearItem$months$inde = yearItem.months[index]) === null || _yearItem$months$inde === void 0 ? void 0 : _yearItem$months$inde.date);
  }, [isActiveYear, activeMonth, yearItem]);
  var {
    onFocus,
    onBlur
  } = useFocus({
    ref: itemTriggerRef,
    isFocused: isFocusedYear,
    handleOnFocus: () => {
      onFocusYearChange(yearItem.year, itemTriggerRef);
    },
    handleOnBlur: () => {
      onFocusYearChange(undefined);
    }
  });
  var {
    onKeyDown
  } = useKeyDown({
    handleArrowKey: key => {
      if (key === 'ArrowDown') {
        onFocusYearChange(yearItem.year + 1, itemTriggerRef);
      } else if (key === 'ArrowUp') {
        onFocusYearChange(yearItem.year - 1);
      }
    },
    handleSelectKey: () => {
      onToggleYear(yearItem.year, itemRef);
    },
    handleBlur: onBlurYear,
    handleEscape
  }); // The focusable year is the active year or the focused year.

  var isFocusable = focusedYear ? isFocusedYear : isActiveYear;
  return /*#__PURE__*/_jsxs(Box, {
    __css: styles['yearSelectionListItem'],
    "data-testid": "year-selection-item",
    ref: itemRef,
    role: "menuitem",
    children: [/*#__PURE__*/_jsx(Box, {
      as: "button",
      __css: styles['yearSelectionListItemTrigger'],
      onMouseDown: () => {
        onToggleYear(yearItem.year, itemRef);
      },
      "aria-expanded": isOpen,
      "aria-label": "Year ".concat(yearItem.year),
      "aria-disabled": yearItem.isDisabled,
      tabIndex: isFocusable ? 0 : -1,
      ref: itemTriggerRef,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      children: yearItem.year
    }), isOpen && /*#__PURE__*/_jsx(Box, {
      __css: styles['monthSelectionGrid'],
      role: "radiogroup",
      "aria-label": "Month selection options",
      children: yearItem.months.map((month, i) => /*#__PURE__*/_jsx(MonthSelectionCell, _objectSpread({
        month: month,
        isActiveMonth: isActiveMonth(i),
        isActiveYear: isActiveYear,
        goToYear: goToYear,
        focusedMonth: focusedMonth,
        onFocusMonthChange: onFocusMonthChange,
        onBlurMonth: () => {
          var _itemTriggerRef$curre;

          // returns the focus to the trigger button.
          (_itemTriggerRef$curre = itemTriggerRef.current) === null || _itemTriggerRef$curre === void 0 ? void 0 : _itemTriggerRef$curre.focus();
        },
        handleEscape: handleEscape
      }, month), formatDate(month.date)))
    })]
  });
};
YearSelectionListItem.displayName = 'YearSelectionListItem';
//# sourceMappingURL=YearSelectionListItem.js.map